// Small helpers shared by the application list screens (staff + admin).

// Applicant display name: personal-info section first, then the account name.
export function applicantNameOf(item) {
  if (!item) return "N/A";
  const secName = item.section_a1
    ? `${item.section_a1.first_name || ""} ${item.section_a1.sur_name || ""}`.trim()
    : "";
  const appName = item.applicant_name
    ? item.applicant_name
    : item.applicant
    ? `${item.applicant.first_name || ""} ${item.applicant.last_name || ""}`.trim() ||
      item.applicant.username
    : "";
  return secName || appName || "N/A";
}

// Application number, with the same ECU-000123 fallback the other lists use.
export function applicationNoOf(item) {
  if (!item) return "N/A";
  return item.application_no || `ECU-${String(item.id).padStart(6, "0")}`;
}